import {RolesI18n} from '@/locales/base.message.locales';

export const roles: RolesI18n = {
  admin: 'Administrador',
  judge: 'Juiz',
  advisor: 'Conselheiro',
  master_admin: 'Admin',
  partner: 'Parceiro',
  contestant: 'Participante'
};
